export enum ClientType {
    Standard = 'Standard',
    Premium = 'Premium',
}

export const CLIENT_TYPES = [
    { label: 'Standard', value: ClientType.Standard },
    { label: 'Premium', value: ClientType.Premium },
];
